import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectClientesItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: Array.isArray(props.initialOptions) ? props.initialOptions : [],
      cargando: false,
      primerCarga: false,
      texto: '',
    };

    this.buscarClientes = debounce(this.buscarClientes.bind(this), 300);
  }

  componentDidMount() {
    this.buscarClientes('');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialOptions !== this.props.initialOptions && Array.isArray(this.props.initialOptions) && this.props.initialOptions.length) {
      this.setState(prev => {
        const existingIds = new Set(prev.opciones.map(c => c._id.toString()));
        const nuevas = this.props.initialOptions.filter(c => !existingIds.has(c._id.toString()));
        return nuevas.length ? { opciones: [...prev.opciones, ...nuevas] } : null;
      });
    }
    if(prevProps.value !== this.props.value) {
      if (Array.isArray(this.props.value)) {
        const idsEnOpciones = new Set(this.state.opciones.map(c => c._id.toString()));
        const idsFaltantes = this.props.value.filter(id => id && !idsEnOpciones.has(id.toString()));
        if (idsFaltantes.length) {
          this.buscarClientesPorIds(idsFaltantes);
        }
      } else if (this.props.value) {
        const buscarCliente = this.state.opciones.find(cliente => cliente._id.toString() === this.props.value.toString());
        if (!buscarCliente){
          this.buscarClientes(this.props.value || '', true);
        }
      }
    }
  }

  async buscarClientesPorIds(ids) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "clientes/selectClientesItem",
        {
          empresaId: this.props.empresaId,
          ids,
          clientePortal: this.props?.clientePortal || false,
          ventaId: this.props?.ventaId,
          soloDuenosInsumos: this.props?.soloDuenosInsumos || false,
          excluirClienteId: this.props?.excluirClienteId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState(prev => {
          const existentes = new Set(prev.opciones.map(c => c._id.toString()));
          const encontrados = new Set(res.data.clientes.map(c => c._id.toString()));
          const nuevos = res.data.clientes.filter(c => !existentes.has(c._id.toString()));
          // Placeholders para IDs que no existen en DB
          const noEncontrados = ids
            .filter(id => !encontrados.has(id.toString()) && !existentes.has(id.toString()))
            .map(id => ({ _id: id, stringBuscar: 'Cliente eliminado' }));
          return { opciones: [...prev.opciones, ...nuevos, ...noEncontrados] };
        });
      }
    } catch (error) {
      console.error("Error al cargar clientes por IDs:", error);
    } finally {
      this.setState({ cargando: false });
    }
  }

  async buscarClientes(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "clientes/selectClientesItem",
        {
          empresaId: this.props.empresaId,
          query: append ? (this.state.texto || texto || this.props.value) : (texto || this.props.value),
          skip: append ? this.state.opciones.length : 0,   // saltar los ya cargados
          clientePortal : this.props?.clientePortal || false,
          ventaId: this.props?.ventaId,
          soloDuenosInsumos: this.props?.soloDuenosInsumos || false,
          excluirClienteId: this.props?.excluirClienteId,
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState((prev) => {
          if (append) {
            const existingIds = new Set(prev.opciones.map(c => c._id.toString()));
            const nuevos = res.data.clientes.filter(c => !existingIds.has(c._id.toString()));
            return { opciones: [...prev.opciones, ...nuevos], primerCarga: false, texto: this.state.texto };
          }
          return { opciones: res.data.clientes, primerCarga: false, texto };
        });
        if(this.props.puntoVenta && inicial) {
          this.props.onChange(res.data.clientes[0]?._id, res.data.clientes[0]);
        }
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar clientes:", error);
      this.setState({ opciones: [], texto: append ? this.state.texto : texto });
    } finally {
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      initialOptions,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      onSearch: this.buscarClientes,
      // Mostrar loading cuando está cargando, o mensaje cuando no hay resultados
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando clientes...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron clientes' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode) {
      propsNuevas.mode = mode;
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const cliente = this.state.opciones.find((cliente) => cliente._id === value);
          this.props.onChange(value, cliente)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            // Llegaste al fondo → cargar más
            this.buscarClientes(this.props.value || '', false, true);
          }
        }}
      >
        {this.state.opciones.map((cliente) => (
          <Option key={cliente._id} value={cliente._id}>
            {cliente.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectClientesItem;